import React, { Suspense, lazy } from 'react';

import FullScreenLoading from 'apps/share/blocks/fullScreenLoading';

const LandingPageLazy = lazy(() => import('apps/share/main'));

export default function SharedFilePage(props) {
  return (
    <Suspense fallback={<FullScreenLoading />}>
      <LandingPageLazy {...props} />
    </Suspense>
  );
}
